import { ProjectNew } from '@dc-shared-web/hooks/api/project/types'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { AxiosInstance } from 'axios'
import { useQuery } from 'react-query'

const fetchProjectByUuid = async (
  apiClient: AxiosInstance,
  projectUuid: string
): Promise<ProjectNew> => {
  const { data } = await apiClient.get(`/api/project-info/${projectUuid}`)
  return data
}

export const useGetProjectByUuid = (projectUuid: string) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<ProjectNew, Error>({
    queryKey: ['project', projectUuid],
    queryFn: () => fetchProjectByUuid(apiClient, projectUuid),
    enabled: !!projectUuid,
  })
}
